<template>
  <div class="row">
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons top />
      </form>
    </div>
    <form v-on:submit.prevent>
      <div class="col-md-6">
        <contacts />
      </div>
      <div class="col-md-6">
        <offices />
      </div>
      <div class="col-md-8">
        <socialMedia />
      </div>
    </form>
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons />
      </form>
    </div>
  </div>
</template>

<script>
import contacts from "../elements/contacts.vue";
import offices from "../elements/offices.vue";
import socialMedia from "../elements/socialMedia.vue";
import buttons from "../elements/buttons.vue";
import utils from "./utils.js";

export default {
  name: "contact-page",
  components: {
    contacts: contacts,
    offices: offices,
    socialMedia: socialMedia,
    buttons: buttons
  },
  methods: {
    submit: function() {
      utils.post(this);
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/contactPage.vue